import { createContext, useContext } from "react";

export const NavigationReleaseContext = createContext(false);
export const useNavigationReleased = () => useContext(NavigationReleaseContext);
